/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import { validationSchema } from "../../Context/validation";
import UsePlanHistory from './Hooks/useViewDetails';
import Branch from './branch';
import Client from './client';
import PlanDetails from './planDetails';
import FindPayments from './Hooks/findPayments';

const ViewDetails = () => {
    const {
        view,
        clear,
        setTab,
        setShow,
        setPage,
        assignPlan,
        setNestedTab,
        handleChange,
        getMyPayments,
        setPlanAssignModal,
        planPaymentHistory,
        myPaymentsList,
        setPaymentDetailsModal,
        paymentDetailsModal,
        planAssignModal,
        myPaymentData,
        nestedtab,
        planData,
        PER_PAGE,
        spinner,
        formik,
        count,
        show,
        page,
        tab,
        data,
        filter,
        setData,
        exportData,

    } = UsePlanHistory()

    const setNestedPage = (newPage) => {
        setNestedTab((prevNestedTab) => ({
            ...prevNestedTab,
            nestedPage: newPage
        }));
    };

    return (
        <section>
            <ToastContainer />
            <div className="m-t-3 cus-padd cusheight">
                {spinner ? <Spinner /> : null}

                {
                    !nestedtab?.show ?
                        <nav className="mb-3">
                            <div className="nav nav-tabs tabber" id="nav-tab" role="tablist">
                                <button className={` ${tab === 1 ? 'activeNav' : 'unActiveNav'} border-0`} onClick={() => { setPage(1); setTab(1); setNestedTab((pre) => ({ ...pre, tab: 1, show: false, nestedPage: 1, nestedCount: '' })) }} id="basicdetails" type="button">
                                    Branch
                                </button>
                                <button
                                    className={` ${tab === 2 ? 'activeNav' : 'unActiveNav'} border-0`}
                                    type="button"
                                    onClick={() => { setPage(1); setTab(2); }}
                                >
                                    Client
                                </button>
                                <button className={` ${tab === 3 ? 'activeNav' : 'unActiveNav'} border-0`} onClick={() => { setPage(1); setTab(3); }} id="basicdetails" type="button">
                                    Plan Details
                                </button>
                                <button
                                    className={` ${tab === 4 ? 'activeNav' : 'unActiveNav'} border-0`}
                                    type="button"
                                    onClick={() => { setTab(4); setPage(1) }}
                                >
                                    Find Payments
                                </button>
                            </div>
                        </nav>
                        :
                        nestedtab.serviceShow ? null :
                            <nav className="mb-3">
                                <div className="nav nav-tabs tabber" id="nav-tab" role="tablist">
                                    <i className="fa-solid fa-angle-left cusgap cursor" onClick={() => { setNestedTab((pre) => ({ ...pre, tab: 1, show: false, nestedPage: 1 })); setData((pre) => ({ ...pre, branchId: '' })) }}></i>
                                    <button className={` ${nestedtab.tab === 1 ? 'activeNav' : 'unActiveNav'} border-0`} onClick={() => setNestedTab((pre) => ({ ...pre, tab: 1, nestedPage: 1 }))} id="basicdetails" type="button">
                                        Services Category
                                    </button>
                                    <button
                                        className={` ${nestedtab.tab === 2 ? 'activeNav' : 'unActiveNav'} border-0`}
                                        type="button"
                                        onClick={() => setNestedTab((pre) => ({ ...pre, tab: 2, nestedPage: 1 }))}
                                    >
                                        Team
                                    </button>
                                </div>
                            </nav>

                }

                {
                    tab === 1 &&
                    <Branch data={data} nestedtab={nestedtab} count={count} PER_PAGE={PER_PAGE} page={page} setNestedTab={setNestedTab}
                        exportData={exportData} setData={setData} setPage={setPage} setNestedPage={setNestedPage} />
                }

                {
                    tab === 2 &&
                    <Client data={data} exportData={exportData} count={count} PER_PAGE={PER_PAGE} page={page} setPage={setPage} />
                }
                {
                    tab === 3 &&
                    <PlanDetails show={show} setShow={setShow} view={view} validationSchema={validationSchema} formik={formik}
                        planData={planData} count={count} PER_PAGE={PER_PAGE} page={page} setPage={setPage} planPaymentHistory={planPaymentHistory}
                        setPlanAssignModal={setPlanAssignModal} planAssignModal={planAssignModal} assignPlan={assignPlan}
                    />

                }

                {
                    tab === 4 &&
                    <FindPayments PER_PAGE={PER_PAGE} page={page} myPaymentData={myPaymentData} paymentDetailsModal={paymentDetailsModal}
                        setPaymentDetailsModal={setPaymentDetailsModal} filter={filter} handleChange={handleChange} clear={clear} myPaymentsList={myPaymentsList} />

                }


            </div>
        </section>
    )
}

export default ViewDetails